<template>
  <el-form ref="ff" :model="detail" label-position="top">
    <el-row :gutter="20">
      <el-col>
        <el-form-item label="角色名称" prop="Name">
          <el-input v-model="detail.Name" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="排序号" prop="Sort">
          <el-input v-model="detail.Sort" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="状态" prop="State">
          <el-switch v-model="detail.State" active-text="启用"> </el-switch>
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="简介" prop="Describe">
          <el-input type="textarea" v-model="detail.Describe" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" icon="el-icon-position" @click="onSubmit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      detail: {}
    }
  },
  props: {
    id: { type: String, default: '' },
    layerid: { type: String, default: null }
  },
  created () {
    return this.$apis.system.role.getData({ id: this.id }).then(res => {
      this.detail = res || {}
    })
  },
  methods: {
    onSubmit () {
      this.$refs["ff"].validate(valid => {
        if (valid) {
          return this.$apis.system.role.submit(this.detail).then(() => {
            this.$parent.loadData()
            this.$message({ message: "数据提交成功！", type: "success" })
            this.$layer.close(this.layerid)
          })
        }
      })
    }
  }
}
</script>